import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useGetToken } from '../../config';

type TCallVariables = {
  token: string;
  id: string;
};

type TVariables = {
  includePrices?: boolean;
  includeActiveAgreement?: boolean;
  includeNextCollectionDate?: boolean;
  pricesForTicketType?: string;
  includeTicketTypes?: boolean;
  limit?: number;
};

export const call = ({
  id,
  token,
  includePrices,
  includeActiveAgreement,
  includeNextCollectionDate,
  pricesForTicketType,
  includeTicketTypes,
  limit,
}: TCallVariables & TVariables) =>
  axios.get(`property/${id}/property-containers`, {
    headers: {
      'X-API-Key': token,
    },
    params: {
      include_prices: includePrices,
      include_active_agreement: includeActiveAgreement,
      include_next_collection_date: includeNextCollectionDate,
      prices_for_ticket_type_id: pricesForTicketType,
      include_ticket_types: includeTicketTypes,
      limit: limit || 100,
    },
  });

const K_GET_PROPERTY_CONTAINERS = 'K_GET_PROPERTY_CONTAINERS';

export const useGetPropertyContainers = (
  propertyId: string,
  params?: TVariables
) => {
  const token = useGetToken();
  return useQuery<$TSFixMe>({
    queryKey: [K_GET_PROPERTY_CONTAINERS, propertyId, { ...(params || {}) }],
    queryFn: () => call({ token, id: propertyId, ...params }),
    // Containers list can be slow (large payload + backend joins). Show the
    // cached list immediately on re-mount while we refetch in the background.
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};

type TCallAgreementsVariables = {
  token: string;
  id: string;
};

export const callAgreements = ({
  id,
  token,
  limit,
}: TCallAgreementsVariables & { limit?: number }) =>
  axios.get(`property/${id}/property-agreements`, {
    headers: {
      'X-API-Key': token,
    },
    params: {
      limit: limit || 100,
    },
  });

const K_GET_PROPERTY_AGREEMENT = 'K_GET_PROPERTY_AGREEMENTS';

export const useGetPropertyAgreements = (
  propertyId: string,
  params?: { limit?: number }
) => {
  const token = useGetToken();
  return useQuery<$TSFixMe>({
    queryKey: [K_GET_PROPERTY_AGREEMENT, propertyId, { ...(params || {}) }],
    queryFn: () => callAgreements({ token, id: propertyId, ...params }),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
